import * as React from 'react';
import { Button } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import { InstitutionGroup, InstitutionGroupTimeLabel } from 'cb-model';
import { IsAllowed, List, PageTitle, QueryMulti, QuerySingle, Section } from 'gossamer-front-end';
import { getFilter } from 'gossamer-unified';

export const InstitutionGroupTimeLabelList = (): React.JSX.Element => {
  const params = useParams();
  return (
    <>
      <PageTitle title="Rotations" subtitle="A sequence of named periods into which this group's event are allocated" />

      <Section>
        <QueryMulti
          entity={InstitutionGroupTimeLabel}
          alterEntity={(localEntity: typeof InstitutionGroupTimeLabel) => {
            localEntity.fields.institution_group_id.listColumn = false;
          }}
          queryOptions={{
            where: {
              and: [getFilter('institution_group_id', 'eq', params.key)],
            },
          }}
          render={List}
        />
        <IsAllowed entity={InstitutionGroupTimeLabel} action="update">
          <Link to={`/admin/institution-group/time-labels-grid/${params.key}`}>
            <Button>Update</Button>
          </Link>
        </IsAllowed>
      </Section>
    </>
  );
};
